import { IconKeys } from '../Icon/IconKeys';

export function generateFilterData(type: string): { icon: IconKeys, label: string } {
  switch (type) {
    case 'status':
      return {
        icon: IconKeys.PULSE,
        label: 'Status',
      };
    case 'category':
      return {
        icon: IconKeys.CAR_OUTLINED,
        label: 'Vehicle type',
      };
    case 'vehicle._id':
    case 'driverId':
    case 'vehicleId':
      return {
        icon: IconKeys.ASSIGNED_STATUS,
        label: 'Assigned status',
      };
    case 'sortBy':
      return {
        icon: IconKeys.LIST,
        label: 'Sort by',
      };
    case 'sensor':
      return {
        icon: IconKeys.SPARK_OUTLINED,
        label: 'Sensor type',
      };
    case 'name':
      return {
        icon: IconKeys.EVENT,
        label: 'Alert type',
      };
    case 'riskLevel':
      return {
        icon: IconKeys.RISK_LEVEL,
        label: 'Risk level',
      };
    case 'groupIds':
      return {
        icon: IconKeys.USER_MANAGEMENT,
        label: 'Groups',
      };
    case 'isOnline':
      return {
        icon: IconKeys.ASSIGNED_STATUS,
        label: 'Online status',
      };
    case 'cameraId':
      return {
        icon: IconKeys.VIDEO,
        label: 'Camera type',
      };
    case 'isThumbnail':
      return {
        icon: IconKeys.VIDEO,
        label: 'Video',
      };
    case 'isValid':
      return {
        icon: IconKeys.ALERT,
        label: 'Status',
      };
    case 'alertId':
      return {
        icon: IconKeys.BELL,
        label: 'Video type',
      };
    case 'role':
      return {
        icon: IconKeys.USER,
        label: 'User role',
      };
    case 'group':
      return {
        icon: IconKeys.USER_MANAGEMENT,
        label: 'Group',
      };
    default:
      return {
        icon: IconKeys.BELL,
        label: `Unknown type: ${type}`,
      };
  }
}

function getFilterKeys(options: Record<string, string>[] = []): string[] {
  const res = options.map((o: any) => Object.keys(o)[0]);
  return res;
}

export function generateFilterValue(values: string[] = [], options: Record<string, string>[] = []): string {
  if (getFilterKeys(options).includes(values[0])) {
    const valuesList = values.map((option: string) => options.filter((o: any) => Object.prototype.hasOwnProperty.call(o, option))[0][option]);
    // return valuesList.length > 1 ? valuesList.join(', ') : valuesList[0];
    if (!valuesList.length) {
      return 'All';
    }
    return valuesList.length > 1 ? 'few selected' : valuesList[0];
  }

  return 'All';
}
